/* ----- code generated do not modify ----- */
var components_combo_box_locale33 = {
  "buttonLabel": "\u663E\u793A\u5EFA\u8BAE",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "\u6709 ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u4E2A\u9009\u9879");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u4E2A\u9009\u9879");
      }
    }), "\u53EF\u7528\u3002");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      "true": function _true() {
        return "\u8FDB\u5165\u4E86 ".concat(args.groupTitle, " \u7EC4\uFF0C\u5176\u4E2D\u6709 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u4E2A\u9009\u9879");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u4E2A\u9009\u9879");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      "true": ", \u5DF2\u9009\u62E9",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u5EFA\u8BAE",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u5DF2\u9009\u62E9");
  }
};

export { components_combo_box_locale33 as default };
//# sourceMappingURL=zh-CN.esm.js.map
